<template>
  <div>
    <AppLayout title="Formas de Pagamento">
      <template #actions>
        <button type="button" class="btn btn-primary" @click="show_new">Nova Forma de Pagamento</button>
      </template>

      <p class="text-muted mb-3">
        Cadastre quantas formas de pagamento a loja precisar — por exemplo, uma para cada maquininha de cartão.
        O <strong>tipo</strong> define o comportamento (troco só se aplica a "Dinheiro", "Fiado" lança na conta do cliente); o <strong>nome</strong> é livre.
      </p>

      <div class="table-card">
        <table class="table">
          <thead>
            <tr>
              <th>Nome</th>
              <th>Tipo</th>
              <th>Status</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="metodo in lista_metodos" :key="metodo.id">
              <td>{{ metodo.name }}</td>
              <td><span class="badge" :class="badgeClass(metodo.type)">{{ formaterService.payment(metodo.type) }}</span></td>
              <td>
                <span class="badge" :class="metodo.active ? 'text-bg-success' : 'text-bg-secondary'">
                  {{ metodo.active ? 'Ativa' : 'Inativa' }}
                </span>
              </td>
              <td style="width:50px"><button @click="show_edit(metodo)" type="button" class="btn btn-info btn-sm"><i class="bi bi-pencil-square"></i></button></td>
              <td style="width:50px"><button @click="show_delet(metodo)" type="button" class="btn btn-danger btn-sm"><i class="bi bi-trash-fill"></i></button></td>
            </tr>
            <tr v-if="!lista_metodos.length">
              <td colspan="5" class="text-center text-muted">Nenhuma forma de pagamento cadastrada.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </AppLayout>

    <!-- Modal Forma de Pagamento -->
    <div class="modal fade" id="modal_metodo" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <div v-if="edit">
              <h5 class="modal-title">Editar Forma de Pagamento</h5>
            </div>
            <div v-else>
              <h5 class="modal-title">Nova Forma de Pagamento</h5>
            </div>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form id="form-metodo">
              <div class="mb-3">
                <label for="inp_name" class="form-label">Nome:</label>
                <input v-model="metodo_obj.name" type="text" class="form-control" name="inp_name" id="inp_name" placeholder="Ex.: Maquininha Stone">
              </div>
              <div class="mb-3">
                <label for="inp_type" class="form-label">Tipo:</label>
                <select v-model="metodo_obj.type" class="form-select" id="inp_type">
                  <option value="cash">Dinheiro (permite calcular troco)</option>
                  <option value="pix">Pix</option>
                  <option value="card">Cartão</option>
                  <option value="onaccount">Fiado (lança na conta do cliente)</option>
                </select>
              </div>
              <div v-if="edit" class="form-check form-switch">
                <input v-model="metodo_obj.active" class="form-check-input" type="checkbox" role="switch" id="inp_active">
                <label class="form-check-label" for="inp_active">Ativa (aparece na tela de venda do PDV)</label>
              </div>
            </form>
          </div>
          <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
              <button type="submit" @click="action()" class="btn btn-primary">Salvar</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal deletar -->
    <div class="modal fade" id="modal_deletar" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title">Excluir forma de pagamento?</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p>{{ metodo_obj.name }}</p>
            <p class="text-muted small mb-0">Se ela já foi usada em alguma venda, não será possível excluir — desative-a em vez disso.</p>
          </div>
          <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
              <button type="submit" @click="deleteMetodo" class="btn btn-danger">Confirmar</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal Feedback -->
    <div class="modal fade" id="modal_feedback" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title">{{ msn_feedback_titulo }}</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p>{{ msn_feedback }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive, ref } from 'vue';
import AppLayout from "@/components/AppLayout.vue";
import { Modal } from "bootstrap";
import { formasDePagamento } from "@/models/formasDePagamento";
import formaterService from "@/services/formaterService";

export default {
  name: 'PaymentMethodsView',
  components: {
    AppLayout
  },
  setup(props) {
    const Metodos = formasDePagamento()
    const lista_metodos = ref([]);

    const edit = ref(false);
    const msn_feedback = ref('');
    const msn_feedback_titulo = ref('Sucesso');

    let modal = '';

    const metodo_obj = reactive({
      'id': '',
      'name': '',
      'type': 'card',
      'active': true,
    })

    function openModal(elemento) {
      const modalElement = document.getElementById(elemento);
      modal = new Modal(modalElement);
      modal.show();
    }

    function closeModal() {
      modal.hide();
    }

    function badgeClass(type) {
      switch (type) {
        case 'cash': return 'text-bg-success';
        case 'pix': return 'text-bg-info';
        case 'card': return 'text-bg-primary';
        case 'onaccount': return 'text-bg-warning';
        default: return 'text-bg-secondary';
      }
    }

    function limparDados() {
      metodo_obj.id = '';
      metodo_obj.name = '';
      metodo_obj.type = 'card';
      metodo_obj.active = true;
    }

    function setItens(item) {
      metodo_obj.id = item.id;
      metodo_obj.name = item.name;
      metodo_obj.type = item.type;
      metodo_obj.active = item.active;
    }

    const show_new = () => {
      limparDados();
      edit.value = false;
      openModal('modal_metodo');
    }

    const show_edit = (item) => {
      edit.value = true;
      setItens(item);
      openModal('modal_metodo');
    }

    const show_delet = (item) => {
      setItens(item);
      openModal('modal_deletar');
    }

    const listMetodos = async () => {
      lista_metodos.value = await Metodos.list() ?? [];
    }

    const saveMetodo = async () => {
      if (await Metodos.createItem(metodo_obj)) {
        closeModal();
        msn_feedback_titulo.value = 'Sucesso';
        msn_feedback.value = 'Forma de pagamento cadastrada com sucesso!';
        openModal('modal_feedback');
        listMetodos();
      } else {
        console.log('Erro ao cadastrar forma de pagamento');
      }
    }

    const updateMetodo = async () => {
      if (await Metodos.updateItem(metodo_obj)) {
        closeModal();
        msn_feedback_titulo.value = 'Sucesso';
        msn_feedback.value = 'Forma de pagamento atualizada com sucesso!';
        openModal('modal_feedback');
        listMetodos();
      } else {
        console.log('Erro ao atualizar forma de pagamento');
      }
    }

    const deleteMetodo = async () => {
      const resultado = await Metodos.deleteItem(metodo_obj.id);
      closeModal();
      if (resultado === true) {
        msn_feedback_titulo.value = 'Sucesso';
        msn_feedback.value = 'Forma de pagamento excluída com sucesso!';
      } else {
        msn_feedback_titulo.value = 'Não foi possível excluir';
        msn_feedback.value = typeof resultado === 'string'
          ? resultado
          : 'Erro ao excluir forma de pagamento.';
      }
      openModal('modal_feedback');
      listMetodos();
    }

    const action = () => {
      if (edit.value) {
        updateMetodo();
      } else {
        saveMetodo();
      }
    }

    onMounted(function () {
      listMetodos();
    });

    return {
      lista_metodos,
      metodo_obj,
      edit,
      msn_feedback,
      msn_feedback_titulo,
      show_new,
      show_edit,
      show_delet,
      deleteMetodo,
      action,
      badgeClass,
      formaterService,
    }
  },
}
</script>
